import { Profile } from 'helpers/userProfile';
import { FilterContext } from '../contexts/FilterContext';
import { Moment } from 'moment-timezone';
import { endOfMonth, startOfMonth } from 'date-fns';
import { t } from 'i18next';

export interface FilterStateRoute {
  client?: string;
  units?: string[];
  states?: string[];
}

type ParamType = 'agua' | 'unidades' | 'energia' | 'maquinas';

type AnalysisFilterOption<Value = number> = { value: Value, name: string };
type AnalysisSelectedOption = {
  label: string;
  values: AnalysisFilterOption[]
}

export function handleFilterStateRoute(
  client: string | undefined,
  selectedOptions: FilterContext['selectedOptions'],
  profile: Profile,
): FilterStateRoute {
  const filter: FilterStateRoute = {};

  if (selectedOptions.group?.units.length) {
    filter.units = selectedOptions.group.units.map((unit) => unit.toString());
  }

  if (selectedOptions.state?.length) {
    filter.states = selectedOptions.state;
  }

  if (profile.manageMultipleClients && client) {
    filter.client = client;
  }

  return filter;
}

export function handleOverviewStateFilters(
  filterState: FilterStateRoute | undefined,
  state: {
    selectedState: string[],
    selectedUnit: string[],
    selectedClientFilter: string[],
    startDate?: Date | Moment | null,
    endDate?: Date | Moment | null,
  },
  render: () => void,
  paramType?: string,
): void {
  // TODO - Adicionar outros cards de parâmetros
  if (!filterState || !isParamType(paramType)) return;

  if (filterState.client) {
    state.selectedClientFilter = [filterState.client];
  }

  if (filterState.states?.length) {
    state.selectedState = filterState.states;
  }

  if (filterState.units?.length) {
    state.selectedUnit = filterState.units;
  }

  if (paramType === 'energia') {
    state.endDate = endOfMonth(new Date());
    state.startDate = startOfMonth(new Date());
  }

  render();
}

function isParamType(type: string | undefined): type is ParamType {
  return !!type && (type === 'agua' || type === 'unidades' || type === 'energia' || type === 'maquinas');
}

export function handleFiltersAnalysis(filters: {
  clients: AnalysisFilterOption[],
  states: AnalysisFilterOption[],
  units: AnalysisFilterOption[]
}, state: {
    selectedState: string[],
    selectedUnit: string[],
    selectedClientFilter: string[],
  }): {
  clients: AnalysisSelectedOption,
  states: AnalysisSelectedOption,
  units: AnalysisSelectedOption,
} {
  return {
    clients: {
      label: t('cliente'),
      values: filters.clients.filter((item) => state.selectedClientFilter.includes(String(item.value))),
    },
    states: {
      label: t('estado'),
      values: filters.states.filter((item) => state.selectedState.includes(String(item.value))),
    },
    units: {
      label: t('unidade'),
      values: filters.units.filter((item) => state.selectedUnit.includes(String(item.value))),
    },
  };
}
